import { render, staticRenderFns } from "./VariableTag.vue?vue&type=template&id=512e2268&scoped=true"
import script from "./VariableTag.vue?vue&type=script&lang=js"
export * from "./VariableTag.vue?vue&type=script&lang=js"
import style0 from "./VariableTag.vue?vue&type=style&index=0&id=512e2268&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512e2268",
  null
  
)

export default component.exports